import type { AssetsRecommendationData } from '@/modules/Asset/interface/Recommendation';
import { useQuery } from '@tanstack/react-query';
import { api } from '@/libs/axios/apiClient';
import { apiConfig } from '@/config/api';

export const useGetAssetsRecommendations = () =>
  useQuery({
    queryKey: ['assets', 'recommendations'],
    queryFn: getAssetsRecommendations,
  });

const getAssetsRecommendations = async () => {
  const { data } = await api.get<AssetsRecommendationData[]>(
    apiConfig.routes.assets.recommendation
  );
  return data;
};
